export const focusPickerSearch = () => {
    setTimeout(() => {
        const popups = document.querySelectorAll(
            ".rs-picker-menu.rs-picker-select-menu, .rs-picker-menu.rs-picker-check-menu"
        );
        const popup = popups[popups.length - 1];

        const input = popup?.querySelector("input");
        if (!input) return;

        input.focus();
        input.select();
    }, 0);
};